var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5075 10.7119V7.1486C13.5075 6.20354 13.1321 5.2972 12.4638 4.62894C11.7956 3.96069 10.8892 3.58527 9.94419 3.58527C8.99914 3.58527 8.09279 3.96069 7.42453 4.62894C6.75628 5.2972 6.38086 6.20354 6.38086 7.1486V10.7119",
    stroke: "#141314",
    strokeWidth: 3.09289,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2871 10.7113H4.5971C3.61311 10.7113 2.81543 11.509 2.81543 12.493V17.838C2.81543 18.822 3.61311 19.6197 4.5971 19.6197H15.2871C16.2711 19.6197 17.0688 18.822 17.0688 17.838V12.493C17.0688 11.509 16.2711 10.7113 15.2871 10.7113Z",
    fill: "#32A0FF",
    stroke: "#32A0FF",
    strokeWidth: 3.09289,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.73ada546b74f94cdedfca1863fcd1ffa.svg";
export { ForwardRef as ReactComponent };